import axios from '../plugins/axios';

const API_URL = '/admin/space-bookings';

export default {
  async getSpaceBookings(filters = {}) {
    let url = `${API_URL}?_with_[payments]=&_with_[breaks]=&_no_pagination_=1&_sort_=id:desc`;
    
    if (filters.customer) {
      url += `&_filters_[]=customer__contains&customer__contains=${encodeURIComponent(filters.customer)}`;
    }
    
    console.log('API Request URL:', url);
    
    try {
      const response = await axios.get(url);
      console.log('API Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  },

  async addSpaceBooking(bookingData) {
    const response = await axios.post(API_URL, bookingData);
    return response.data;
  },

  async updateSpaceBooking(bookingId, bookingData) {
    const response = await axios.put(`${API_URL}/${bookingId}`, bookingData);
    return response.data;
  },

  async deleteSpaceBooking(bookingId) {
    const response = await axios.delete(`${API_URL}/${bookingId}`);
    return response.data;
  },
  
  async getPayments(bookingId) {
    const response = await axios.get(`${API_URL}/${bookingId}/payments`);
    return response.data;
  },
  
  async addPayment(bookingId, paymentData) {
    const response = await axios.post(`${API_URL}/${bookingId}/payments`, paymentData);
    return response.data;
  }
}; 